import { render, staticRenderFns } from "./HabeasDataNotFound.vue?vue&type=template&id=73edc175&scoped=true"
import script from "./HabeasDataNotFound.vue?vue&type=script&lang=js"
export * from "./HabeasDataNotFound.vue?vue&type=script&lang=js"
import style0 from "./HabeasDataNotFound.vue?vue&type=style&index=0&id=73edc175&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73edc175",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73edc175')) {
      api.createRecord('73edc175', component.options)
    } else {
      api.reload('73edc175', component.options)
    }
    module.hot.accept("./HabeasDataNotFound.vue?vue&type=template&id=73edc175&scoped=true", function () {
      api.rerender('73edc175', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/public/HabeasDataNotFound.vue"
export default component.exports